<template>
    <div class="form-group">
        <label>{{ field.name }}</label>
        <ValidationProvider :name="field.name" :rules="getValidationRules()" mode="eager" v-slot="{ errors }">
            <multiselect
                :id="field.type + '_' + entradaIndex + '_' + fieldIndex"
                v-if="field.type === 'select' || field.type === 'multiselect'"
                v-model="valueSelect"
                :options="field.options"
                label="name"
                track-by="value"
                :multiple="field.type === 'multiselect' ? true : false"
                :disabled="desactivar"
                :placeholder="field.name"
                @input="handleInput"
                v-bind="$attrs"
                :style="(url.includes('admin') && !url.includes('venta') ? 'width: 92%;' : '') + ' z-index: 999'"
            >
            </multiselect>
            <div v-else-if="field.type === 'textarea'">
                <CkEditorComponent :id="field.type + '_' + entradaIndex + '_' + fieldIndex" v-model="valueSelect" @change="handleInput"/>
            </div>
            <div :class="'custom-control custom-' + field.type" v-else-if="field.type === 'checkbox' || field.type === 'radio'" @change="handleInput">
                <input class="custom-control-input" :id="field.type + '_' + entradaIndex + '_' + fieldIndex" v-model="valueSelect" :type="field.type" @change="handleInput" v-bind="$attrs" :class="errors[0] ? 'is-invalid' : ''" />
                <label class="custom-control-label pt-1" :for="field.type + '_' + entradaIndex + '_' + fieldIndex">{{ field.name }}</label>
            </div>
            <template v-else>
                <input :id="field.type + '_' + entradaIndex + '_' + fieldIndex" v-model="valueSelect" :type="field.type != 'email' ? field.type : ''" @change="handleInput" :placeholder="field.name" v-bind="$attrs" class="form-control" :class="errors[0] ? 'is-invalid' : ''" />
            </template>
            <div v-if="field.type === 'range' && valueSelect && !url.includes('campos-personalizados')" class="d-flex justify-content-between align-items-center">
                <h5>Valor elegido: {{ valueSelect }}</h5>
                <button class="button small-button" type="button" @click="valueSelect = null">Limpiar valor</button>
            </div>

            <span v-if="errors[0] || (field.type === 'checkbox' && checkboxError)" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] || `El campo ${field.name} es obligatorio` }}</span>
        </ValidationProvider>
    </div>
</template>

<script>
import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';

export default {
    props: ['field', 'desactivar', 'value', 'entradaIndex', 'fieldIndex'],
    data() {
        return {
            valueSelect: this.value,
            checkboxError: false
        }
    },
    methods: {
        handleInput(e) {
            var fieldValue = null;

            if (this.field.type === 'select') {
                fieldValue = e.name;
            } else if(this.field.type === 'multiselect') {
                fieldValue = e.map(i => i.name).join(', ')
            } else if(this.field.type === 'textarea') {
                fieldValue = e;
            } else if (this.field.type === 'checkbox' || this.field.type === 'radio') {
                fieldValue = e.target.checked;
                if (this.field.required) {
                    if (!fieldValue || fieldValue == false) {
                        this.checkboxError = true;
                    } else {
                        this.checkboxError = false;
                    }
                }
            } else {
                fieldValue = e.target.value;
            }

            this.$emit('input', fieldValue, this.checkboxError);
        },
        getValidationRules() {
            let rules = '';
            switch (this.field.type) {
            case 'email':
                rules = 'email';
                break;
            case 'url':
                rules = 'url';
                break;
            case 'number':
                rules = 'numeric';
                if (this.field.min_value) rules += '|min_value:' + parseInt(this.field.min_value);
                if (this.field.max_value) rules += '|max_value:' + parseInt(this.field.max_value);
                break;
            case 'range':
                rules = 'numeric';
                if (this.field.min_value) rules += '|min_value:' + parseInt(this.field.min_value);
                if (this.field.max_value) rules += '|max_value:' + parseInt(this.field.max_value);
                break;
            default:
                rules = '';
                break;
            }

            if (this.field.required && !this.valueSelect) {
                rules += '|required';
            }

            return rules;
        }
    },
    computed: {
        url() {
            return window.location.href;
        }
    },
    components: {
        CkEditorComponent
    }
}
</script>